export default __webpack_public_path__ + "static/media/phone_icon.42252f9b.svg";